import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import EventEmitter from 'wolfy87-eventemitter';
import getDisplayName from '../services/get-display-name';

const emitter = new EventEmitter();

export type WithEventEmitter = {
  eventEmitter: EventEmitter;
};

export default function withEventEmitter<P extends WithEventEmitter>(
  WrappedComponent: React.ComponentType<P>,
) {
  const Wrapper = (props: Omit<P, keyof WithEventEmitter>) => {
    return <WrappedComponent {...(props as P)} eventEmitter={emitter} />;
  };

  Wrapper.displayName = `WithEventEmitter(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
}
